import moment from "moment";

import { FileType } from "@/Common/Models/FileType";
import { MessageOrTaskContext } from "@/Common/Models/UI/Enums";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ISendTaskOrMessagePopupModel } from "@/Communications/Models/UI/ITaskMessagePopupModel";

class SendTaskOrMessageAction extends BaseAction {
    public SaveTask(model: ISendTaskOrMessagePopupModel): void {
        this.ProcessTask(ServerOperations.Server.Myle_SaveSendMessage, model, true);
    }

    public SubmitTask(model: ISendTaskOrMessagePopupModel): void {
        this.ProcessTask(ServerOperations.Server.Myle_SaveSendMessage, model, false);
    }

    private ProcessTask(operation: number, model: ISendTaskOrMessagePopupModel, IsDraft: boolean): void {
        const isTask = model.get("IsTask") ?? false;
        const message = {
            StartDate: isTask ? this.formattedDate(model.get("StartDate")) : null,
            DueDate: isTask ? this.formattedDate(model.get("EndDate")) : null,
            Subject: model.get("Subject"),
            IsTask: isTask,
            Version: 2,
            IsGroupTask: isTask && model.get("SelectedTypeOfTask") === "group",
            TypeTaskLookupId: isTask ? model.get("SelectedType") : null,
            PriorityLookupId: model.get("SelectedPriorityId"),
            FromContactId: sessionStore.individualContactId,
            Body: model.get("Body")
        };

        var patientIds = model.get("SelectedPatients").map(r => r.ContactId);
        var clinicianIds = model.get("SelectedClinicians").map(r => r.ContactId);

        const request = {
            Message: message,
            PatientIds: patientIds.toArray(),
            PracticiansIds: clinicianIds.toArray(),
            Attachments: [],
            actionType: IsDraft ? 0 : 1, // 0 for Save, 1 for Send
            Context: MessageOrTaskContext.Unspecified
        };

        if (model.get("IsFolderChecked")) {
            if (model.get("TempDocument")) {
                request.Attachments = model
                    .get("TempDocument")
                    .Model.DocumentPathList
                    .map(doc => ({ Id: doc.DocumentId, FileType: FileType.DOCUMENT }));
            }
            else if (model.get("TempAttachedLabFillerID") != null && model.get("TempAttachedLabFillerID") != "")
                request.Attachments.push({ Id: model.get("TempAttachedLabFillerID"), FileType: FileType.LAB });
        }

        this.Execute(operation, request);
    }

    private formattedDate(date: Date): string {
        return date
            ? moment(date).format()
            : null;
    }

    public verifyEmployeesInVacation(ids: string[]): void {
        let requestData = {
            EmployeeIds: ids
        };

        this.Execute(ServerOperations.Server.Myle_Communications_VerifyEmployeesOnVacation, requestData);
    }
}

export { SendTaskOrMessageAction };
